// extracted by mini-css-extract-plugin
export var numpadContainer = "_s2-1";
export var phoneButton = "_s2-0";